import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOContent = () => {
  return (
    <div style={{ display: 'none' }}>
      <Helmet>
        <meta name="keywords" content="siber güvenlik firması, penetrasyon testi firması, sızma testi hizmeti, red team hizmeti, SOC hizmeti, SIEM entegrasyonu, güvenlik danışmanlığı, ISO 27001, TSE onaylı siber güvenlik" />
      </Helmet>
      
      {/* Hidden SEO Content - İndexleme için */}
      <div itemScope itemType="https://schema.org/Service">
        <h1>Türkiye'nin En İyi Siber Güvenlik Firması</h1>
        <p>SULH Siber Güvenlik - ISO 27001 ve TSE onaylı profesyonel siber güvenlik hizmetleri</p>
        
        <h2>Penetrasyon Testi Hizmetleri</h2>
        <p>Network penetrasyon testi, web uygulama sızma testi, mobil uygulama güvenlik testi, wireless güvenlik değerlendirmesi, API güvenlik testi, sosyal mühendislik testleri</p>
        
        <h2>Red Team - Blue Team - Purple Team</h2>
        <p>Profesyonel red team operasyonları, blue team savunma testleri, purple team entegre güvenlik egzersizleri, gerçek dünya saldırı simülasyonları</p>
        
        <h2>SOC ve SIEM Hizmetleri</h2>
        <p>7/24 güvenlik operasyon merkezi, SIEM entegrasyonu ve yönetimi, log yönetimi, tehdit istihbaratı, otomatik tehdit tespiti, olay müdahalesi, incident response</p>
        
        <h2>Zafiyet Analizi ve Güvenlik Denetimi</h2>
        <p>Zafiyet taraması, güvenlik açığı tespiti, risk analizi, güvenlik denetimi, uyumluluk denetimi, penetrasyon testi raporu, zafiyet yönetimi</p>
        
        <h2>Malware Analizi ve Digital Forensics</h2>
        <p>Kötü amaçlı yazılım analizi, ransomware analizi, exploit tespiti, tersine mühendislik, digital forensics, adli bilişim, incident response, güvenli silme</p>
        
        <h2>Güvenlik Sistemleri</h2>
        <p>IDS IPS sistemleri, firewall yönetimi, EDR endpoint detection, NDR network detection, MDR managed detection, DLP data loss prevention, threat intelligence</p>
        
        <h2>Uyumluluk ve Danışmanlık</h2>
        <p>ISO 27001 danışmanlığı, KVKK uyumluluk, GDPR compliance, PCI DSS, bilgi güvenliği yönetim sistemi, güvenlik politikası oluşturma, risk yönetimi</p>
        
        <h2>Cloud ve Modern Güvenlik</h2>
        <p>Cloud security, bulut güvenliği, AWS güvenlik, Azure güvenlik, hybrid cloud security, zero trust architecture, ZTNA, VPN güvenliği, multifactor authentication</p>
        
        <h2>Yapay Zeka ve Otomasyon</h2>
        <p>Yapay zeka destekli siber güvenlik, makine öğrenmesi tehdit tespiti, otomatik anomali analizi, davranışsal analiz, güvenlik otomasyonu</p>
        
        <h2>Sektörel Çözümler</h2>
        <p>Finans sektörü siber güvenlik, bankacılık güvenliği, sağlık sektörü veri güvenliği, üretim sektörü siber güvenlik, enerji sektörü güvenlik, kamu kurumları siber güvenlik, KOBİ siber güvenlik çözümleri</p>
        
        <h2>Endüstriyel Güvenlik</h2>
        <p>OT güvenliği, operational technology, SCADA güvenliği, IoT güvenliği, endüstriyel kontrol sistemleri, ICS security</p>
        
        <h2>Güvenlik Eğitimleri</h2>
        <p>Siber güvenlik farkındalık eğitimi, phishing simülasyonu, sosyal mühendislik eğitimi, güvenli kodlama eğitimi, OWASP eğitimi, penetrasyon testi eğitimi</p>
        
        <h2>Tehdit ve Saldırı Koruması</h2>
        <p>Phishing saldırısı koruması, ransomware koruması, DDoS koruması, APT advanced persistent threat, zero day exploit koruması, botnet koruması</p>
        
        <h2>Veri ve Ağ Güvenliği</h2>
        <p>Veri güvenliği, veri gizliliği, veri şifreleme, ağ güvenliği, network segmentation, güvenli iletişim, PKI altyapısı, SSL TLS</p>
        
        <h2>Yerli ve Milli Çözümler</h2>
        <p>Yerli siber güvenlik firması, TSE belgeli firma, Türk siber güvenlik şirketi, milli siber güvenlik çözümleri</p>
        
        <h2>Bölgesel Hizmetler</h2>
        <p>İzmir siber güvenlik, İstanbul siber güvenlik, Ankara siber güvenlik, Türkiye geneli hizmet</p>
        
        <h2>Hizmet Modelleri</h2>
        <p>SOC as a service, managed security services, security consulting, penetration testing as a service, vulnerability management as a service</p>
      </div>
    </div>
  );
};

export default SEOContent;
